import * as PropertyTypes from 'customer-data-objects/property/PropertyTypes';
import { hasPercentageQuickFilter } from '../../../permissions/gates';
import { resolveIsUngated } from '../../../utils/UserInfoHelper';
import { shouldUseEnumComponentsForExternalOptionsField } from '../../../utils/externalOptionsConversionUtils';
import AssociatedRecordQuickFilter from '../quickFiltersBar/AssociatedRecordQuickFilter';
import AssociationLabelQuickFilter from '../quickFiltersBar/AssociationLabelQuickFilter';
import BooleanQuickFilter from '../quickFiltersBar/BooleanQuickFilter';
import DatetimeQuickFilter from '../quickFiltersBar/DatetimeQuickFilter';
import DurationQuickFilter from '../quickFiltersBar/DurationQuickFilter';
import EnumQuickFilter from '../quickFiltersBar/EnumQuickFilter';
import NumberQuickFilter from '../quickFiltersBar/NumberQuickFilter';
import PercentageQuickFilter from '../quickFiltersBar/PercentageQuickFilter';
import StringQuickFilter from '../quickFiltersBar/StringQuickFilter';
import TranscriptQuickFilter from '../quickFiltersBar/transcriptQuickFilter/TranscriptQuickFilter';
import { isRelativeTimeProperty } from '../../../utils/isRelativeTimeProperty';
import DateDurationQuickFilter from '../quickFiltersBar/DateDurationQuickFilter';
import { PHONE_NUMBER } from '../../../constants/aditionalPropertyTypes';
export const getQuickFilterComponent = ({
  associatedRecord,
  condition,
  filterFamily,
  getOperatorsForType,
  propertyRecord,
  fieldDefinitions
}) => {
  var _fieldDefinitions$get;
  const {
    name,
    numberDisplayHint
  } = propertyRecord;
  const shouldUseEnumInput = shouldUseEnumComponentsForExternalOptionsField(propertyRecord, condition, filterFamily, getOperatorsForType, resolveIsUngated());
  if (shouldUseEnumInput) {
    return EnumQuickFilter;
  }
  if (name === 'associations.labeled') {
    return associatedRecord ? AssociationLabelQuickFilter : AssociatedRecordQuickFilter;
  }
  if (name === 'hs_call_has_transcript') {
    return TranscriptQuickFilter;
  }
  if (numberDisplayHint === 'duration') {
    return DurationQuickFilter;
  }
  if (numberDisplayHint === 'percentage' && hasPercentageQuickFilter()) {
    return PercentageQuickFilter;
  }
  if (isRelativeTimeProperty(propertyRecord)) {
    return DateDurationQuickFilter;
  }

  // If the field definition has an input type, use that instead of the property record type
  const type = (_fieldDefinitions$get = fieldDefinitions === null || fieldDefinitions === void 0 ? void 0 : fieldDefinitions.getIn([name, 'inputType'])) !== null && _fieldDefinitions$get !== void 0 ? _fieldDefinitions$get : propertyRecord.type;
  switch (type) {
    case PropertyTypes.BOOLEAN:
      return BooleanQuickFilter;
    case PropertyTypes.DATE:
    case PropertyTypes.DATE_TIME:
      return DatetimeQuickFilter;
    case PropertyTypes.ENUMERATION:
      return EnumQuickFilter;
    case PropertyTypes.NUMBER:
      return NumberQuickFilter;
    case PropertyTypes.STRING:
    case PHONE_NUMBER:
      return StringQuickFilter;
    default:
      return null;
  }
};